import * as EmailValidator from 'email-validator';
import registerErrors from './errors';

const isNotEmpty = value => value.length > 0;

const isInvalidCharCode = code => code > 256;
const indexesOf = string => [...Array(string.length).keys()];

const hasInvalidCharacters = value =>
  indexesOf(value).some(index => {
    const code = value.charCodeAt(index);
    return isInvalidCharCode(code);
  });

export const isValidPasswordLength = password => password.length > 7;

export const isValidEmailFormat = value => EmailValidator.validate(value);

export const firstName = value => {
  const isValid = isNotEmpty(value) && !hasInvalidCharacters(value);

  const message = () => {
    if (!isNotEmpty(value)) return registerErrors.firstName.empty;
    if (hasInvalidCharacters(value)) return registerErrors.firstName.containsEmoji;
    return '';
  };

  return {
    isValid,
    message: message(),
  };
};

export const lastName = value => {
  const isValid = isNotEmpty(value) && !hasInvalidCharacters(value);

  const message = () => {
    if (!isNotEmpty(value)) return registerErrors.lastName.empty;
    if (hasInvalidCharacters(value)) return registerErrors.lastName.containsEmoji;
    return '';
  };

  return {
    isValid,
    message: message(),
  };
};

export const email = value => {
  const isValid = isNotEmpty(value) && isValidEmailFormat(value) && !hasInvalidCharacters(value);

  const message = () => {
    if (!isNotEmpty(value)) return registerErrors.email.empty;
    if (!isValidEmailFormat(value)) return registerErrors.email.invalidFormat;
    if (hasInvalidCharacters(value)) return registerErrors.email.containsEmoji;
    return '';
  };

  return {
    isValid,
    message: message(),
  };
};

export const confirmEmail = (emailValue, confirmEmailValue) => {
  const emailsMatch = emailValue === confirmEmailValue;
  const isValid =
    isNotEmpty(confirmEmailValue) && emailsMatch && !hasInvalidCharacters(confirmEmailValue);

  const message = () => {
    if (!isNotEmpty(confirmEmailValue)) return registerErrors.confirmEmail.empty;
    if (!emailsMatch) return registerErrors.confirmEmail.mismatch;
    if (hasInvalidCharacters(confirmEmailValue)) return registerErrors.email.containsEmoji;
    return '';
  };

  return {
    isValid,
    message: message(),
  };
};

export const password = value => {
  const isValidLength = value.length >= 8;
  const isValid = isNotEmpty(value) && isValidLength;
  const containsSpaces = value.includes(' ');

  const message = () => {
    if (!isNotEmpty(value)) return registerErrors.password.empty;
    if (!isValidLength) return registerErrors.password.tooShort;
    if (containsSpaces) return registerErrors.password.containsSpaces;
    return '';
  };

  return {
    isValid,
    message: message(),
  };
};

export const confirmPassword = (passwordValue, confirmPasswordValue) => {
  const passwordsMatch = passwordValue === confirmPasswordValue;
  const isValid = isNotEmpty(confirmPasswordValue) && passwordsMatch;

  const message = () => {
    if (!isNotEmpty(confirmPasswordValue)) {
      return registerErrors.confirmPassword.empty;
    }
    if (!passwordsMatch) return registerErrors.confirmPassword.mismatch;
    return '';
  };

  return {
    isValid,
    message: message(),
  };
};
